module.exports = __webpack_public_path__ + "static/media/Lens_Card.45b450d0.png";